module.exports = __webpack_public_path__ + "static/media/38.48bc8fbb.jpg";